import {
	Level,
	LevelCombo,
	LevelModel,
	LevelComboList,
} from '@/core/interfaces';

export const SelectSkinResponseMapper = (levelsModel: LevelModel[]) => {
	let levelsArray: Level[] = [];
	let levelComboList: LevelComboList[] = [];

	if (levelsModel.length > 0) {
		levelsModel.map((item) => {
			let comboLevel: LevelCombo = {
				coinsReward: item.combo.coinsReward,
				diamondsReward: item.combo.diamondsReward,
				diamondsCostReveal: item.combo.diamondsPrice,
			};

			levelComboList.push({
				level: item.level,
				name: item.name,
				shurikenRewards: item.combo.coinsReward,
				diamondsRewards: item.combo.diamondsReward,
			});

			levelsArray.push({
				level: item.level,
				name: item.name,
				requiredPoints: item.requiredStars,
				earnByTap: item.earnByTap,
				maxEnergy: item.maxEnergy,
				image: item.imageUrl,
				bonus: item.referralBonus,
				diamondsReward: item.diamondsReward,
				combo: comboLevel,
			});
		});
	}

	return levelsArray;
};
